<template>
  <card>
    <template v-if="$store.state.activatedLabels.length > 1">

      <div>
        <label>Etiketten Art</label>
      <div class="form-group has-label">
        <div>
          <l-radio v-model="type" inline label="qr">Qr Codes</l-radio>
          <l-radio v-model="type" inline label="bar">Barcodes</l-radio>
        </div>
      </div>
      </div>
      <hr>
    </template>
    <a  style="max-width: 300px;" :href="baseUrl" class="btn btn-primary" role="button">
      Alle Etiketten herunterladen
    </a>
    <div class="row">
      <div class="col-sm-6">
        <hr>
        <form @submit.prevent="submit">
          <label-product-select
            v-for="row in rows" :key="row.key"
            :product-row="row"
            @productSelected="productSelected"
          />
          <div class="d-flex justify-content-between">
            <a :href="baseUrl + queryString" class="btn btn-primary" role="button"
              :disabled="queryString.length === 1"
              :class="queryString.length === 1 ? 'disabled' : ''"
            >
              Etiketten herunterladen
            </a>
            <button class="btn btn-danger"
              @click.prevent="reset"
            >
              <i class="fa fa-times"></i> Reset
            </button>
          </div>
        </form>
      </div>
    </div>
  </card>
</template>

<script>
import LabelProductSelect from './label-product-select'
import { Radio as LRadio } from 'src/components'
import api from 'src/api'

export default {
  components: { LabelProductSelect, LRadio },
  data () {
    return {
      api,
      type: this.$store.state.activatedLabels[0],
      rows: [
        { key: 0, product: null, quantity: 1 }
      ],
      show: true,
      counter: 1
    }
  },
  methods: {
    productSelected () {
      this.rows.unshift({ key: this.counter, product: null, quantity: 1 })
      this.counter++
    },
    reset () {
      this.rows = []
      this.productSelected()
    }
  },
  computed: {
    baseUrl () {
      const base = `${this.api}/`
      return this.type === 'qr' ? base + 'qr_code_labels' : base + 'barcode_labels'
    },
    queryString () {
      return this.rows.reduce((queryString, row) => {
        return row.product ? queryString + `products[${row.product.id}]=${row.quantity}&` : queryString
      }, '?')
    }
  },
  created () {
    if (this.$route.query['product']) {
      this.$http.get(`/products/${this.$route.query['product']}`).then(({ data }) => {
        this.rows[0].product = data
        this.productSelected()
      })
    }
  }
}
</script>
